module.exports={
    "version": 9,
    "compilerVersion": "1.19.0+commit.72eaeba",
    "contract": "Token",
    "md5": "2784cda7c2c25db5b8c98065e9884e09",
    "structs": [
        {
            "name": "LockingScriptParts",
            "params": [
                {
                    "name": "code",
                    "type": "bytes"
                },
                {
                    "name": "data",
                    "type": "bytes"
                }
            ],
            "genericTypes": []
        },
        {
            "name": "OpPushData",
            "params": [
                {
                    "name": "len",
                    "type": "int"
                },
                {
                    "name": "value",
                    "type": "int"
                }
            ],
            "genericTypes": []
        },
        {
            "name": "VarIntData",
            "params": [
                {
                    "name": "len",
                    "type": "int"
                },
                {
                    "name": "value",
                    "type": "int"
                }
            ],
            "genericTypes": []
        },
        {
            "name": "TxInputProof",
            "params": [
                {
                    "name": "hashProof",
                    "type": "bytes"
                },
                {
                    "name": "txHash",
                    "type": "bytes"
                },
                {
                    "name": "outputIndexBytes",
                    "type": "bytes"
                },
                {
                    "name": "sequenceBytes",
                    "type": "bytes"
                }
            ],
            "genericTypes": []
        },
        {
            "name": "TxOutputProof",
            "params": [
                {
                    "name": "txHeader",
                    "type": "bytes"
                },
                {
                    "name": "hashProof",
                    "type": "bytes"
                },
                {
                    "name": "satoshiBytes",
                    "type": "bytes"
                },
                {
                    "name": "scriptHash",
                    "type": "bytes"
                }
            ],
            "genericTypes": []
        }
    ],
    "library": [
        {
            "name": "ProtoHeader",
            "params": [],
            "properties": [],
            "genericTypes": []
        },
        {
            "name": "AmountCheckProto",
            "params": [],
            "properties": [],
            "genericTypes": []
        },
        {
            "name": "TokenProto",
            "params": [],
            "properties": [],
            "genericTypes": []
        },
        {
            "name": "Backtrace",
            "params": [],
            "properties": [],
            "genericTypes": []
        },
        {
            "name": "TxUtil",
            "params": [],
            "properties": [],
            "genericTypes": []
        }
    ],
    "alias": [],
    "abi": [
        {
            "type": "function",
            "name": "unlock",
            "index": 0,
            "params": [
                {
                    "name": "txPreimage",
                    "type": "SigHashPreimage"
                },
                {
                    "name": "prevouts",
                    "type": "bytes"
                },
                {
                    "name": "tokenInputIndex",
                    "type": "int"
                },
                {
                    "name": "amountCheckHashIndex",
                    "type": "int"
                },
                {
                    "name": "amountCheckInputIndex",
                    "type": "int"
                },
                {
                    "name": "amountCheckTxProof",
                    "type": "TxOutputProof"
                },
                {
                    "name": "amountCheckScript",
                    "type": "bytes"
                },
                {
                    "name": "prevTokenInputIndex",
                    "type": "int"
                },
                {
                    "name": "prevTokenAddress",
                    "type": "bytes"
                },
                {
                    "name": "prevTokenAmount",
                    "type": "int"
                },
                {
                    "name": "tokenTxHeader",
                    "type": "bytes"
                },
                {
                    "name": "tokenTxInputProof",
                    "type": "TxInputProof"
                },
                {
                    "name": "prevTokenTxProof",
                    "type": "TxOutputProof"
                },
                {
                    "name": "senderPubKey",
                    "type": "PubKey"
                },
                {
                    "name": "senderSig",
                    "type": "Sig"
                },
                {
                    "name": "contractInputIndex",
                    "type": "int"
                },
                {
                    "name": "contractTxProof",
                    "type": "TxOutputProof"
                },
                {
                    "name": "operation",
                    "type": "int"
                }
            ]
        },
        {
            "type": "constructor",
            "params": [
                {
                    "name": "transferAmountCheckCodeHashArray",
                    "type": "bytes[5]"
                },
                {
                    "name": "unlockAmountCheckCodeHashArray",
                    "type": "bytes[5]"
                }
            ]
        }
    ],
    "stateProps": [],
    "buildType": "debug",
    "file": "file:///Users/ivan/Codes/blockchain/meta-contract/src/mcp02/contract/token/token.scrypt",
    "hex": "515301402097dfd76851bf465e8f715593b217714858bbe9570ff3bd5e33840a34e20ff0262102ba79df5f8ae7604a9830f03c7933028186aede0675a16f025dc4f8be8eec0382201008ce7480da41702918d1ec8e6849ba32b4d65b1e40dc669c31a1e6306b266c5579547985011455931400000000000000000000000000000000000000005179012493007901149300795893007901149300795193007901149300790128930079529355011493007901149300795493<transferAmountCheckCodeHashArray[0]><transferAmountCheckCodeHashArray[1]><transferAmountCheckCodeHashArray[2]><transferAmountCheckCodeHashArray[3]><transferAmountCheckCodeHashArray[4]><unlockAmountCheckCodeHashArray[0]><unlockAmountCheckCodeHashArray[1]><unlockAmountCheckCodeHashArray[2]><unlockAmountCheckCodeHashArray[3]><unlockAmountCheckCodeHashArray[4]>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",
    "sourceMapFile": "file:///Users/ivan/Codes/blockchain/meta-contract/src/mcp02/contract-desc/token.map.json"
}